import {
	CHECK_PHONE_CODE_SUCCESS,
	LOGIN_ANONYMOUS_FAILURE,
	LOGIN_ANONYMOUS_SUCCESS,
	RESIGNUP_FAILURE,
	RESIGNUP_SUCCESS,
} from 'new-constants/api.constants';
import {DONE_LOGOUT_CONFIRMATION} from 'new-constants/popup.constants';
import {AuthState} from './auth.reducer.types';
import { CAUTH_CLEAR_CUSTOMER_DATA } from '../constants/app-state.constants';

export const initialState: AuthState = {
	cache: {},
	isDataError: false,
};

export const authReducer = (previousState = initialState, action): AuthState => {
	switch (action && action.type) {
		case LOGIN_ANONYMOUS_SUCCESS: {
			const newAuthData = {
				appId: action.payload.appId,
				udid: action.payload.cid,
				secret: action.payload.token,
			};

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[newAuthData.appId]: newAuthData,
				},
			};
		}
			break;
		case LOGIN_ANONYMOUS_FAILURE:
			return {
				...previousState,
				isDataError: action.isDataError,
			};
			break;

		case RESIGNUP_SUCCESS: {
			const newAuthData = {
				appId: action.payload.appId,
				udid: action.payload.cid,
				secret: action.payload.token,
			};

			return {
				...previousState,
				cache: {
					...previousState.cache,
					[newAuthData.appId]: newAuthData,
				},
			};
		}
			break;

		case RESIGNUP_FAILURE:
			return {
				...previousState,
				cache: {},
				isDataError: action.isDataError,
			};
			break;

		case CHECK_PHONE_CODE_SUCCESS:
			return {
				...previousState,
				cache: {
					...previousState.cache,
					[action.payload.data.appId]: {
						appId: action.payload.data.appId,
						udid: action.payload.data.cid,
						secret: action.payload.data.token,
					},
				},
			};
			break;

		case DONE_LOGOUT_CONFIRMATION:
			return {
				...previousState,
				cache: {},
			};
			break;

		case CAUTH_CLEAR_CUSTOMER_DATA:
			const previousCache = previousState.cache;
			delete previousCache[action.appId];
			return {
				...previousState,
				cache: {
					...previousCache,
				},
			};
			break;
		default:
			return previousState;
	}
};
